(()=>{if(!document.documentElement.hasAttribute("data-ff-category"))return;const start=()=>{const body=document.body,mobile=matchMedia("(max-width:1024px)"),header=document.querySelector("#HeaderNavigation"),drawer=document.querySelector("#navigation-mobile"),slot=drawer?.querySelector("[data-navigation-mobile]"),menu=header?.querySelector("[data-ff-a2-nav], [data-navigation] > ul, ul.list-menu"),origin=menu?.parentNode,marker=document.createComment("navigation position");menu&&origin.insertBefore(marker,menu);let returnFocus=null;const closeMenu=(focus=!1)=>{body.classList.remove("menu-open"),document.querySelectorAll(".mobileMenu-toggle").forEach(b=>b.setAttribute("aria-expanded","false")),focus&&returnFocus?.focus()},moveMenu=()=>{closeMenu(),!(!menu||!slot)&&(mobile.matches?slot.contains(menu)||slot.replaceChildren(menu):menu.parentNode!==origin&&marker.after(menu))};moveMenu(),mobile.addEventListener("change",moveMenu),document.querySelectorAll(".mobileMenu-toggle").forEach(b=>{b.setAttribute("aria-controls","navigation-mobile"),b.setAttribute("aria-expanded","false")});const cart=document.querySelector("#halo-cart-sidebar");
// Phone-login popups may return to the homepage and create a new tab.
// Offer a customer-controlled way back to the locally saved trial jars;
// never silently change or recreate a Shopify cart from stored data.
const offerTrialResume=()=>{
  const pathname=location.pathname.replace(/\/$/,"")||"/";
  if(pathname!=="/"&&pathname!=="/cart")return;
  if(pathname==="/cart"&&!document.querySelector("#MainContent")?.textContent?.includes("Your cart is empty"))return;
  try{
    if(sessionStorage.getItem("ff-trial-reminder-dismissed")==="yes")return;
    const saved=JSON.parse(localStorage.getItem("ff-trial-selection-v1")||"null");
    if(saved?.version!==1||!Number.isSafeInteger(saved.savedAt)||Date.now()-saved.savedAt>86400000||saved.savedAt>Date.now()+60000||!Array.isArray(saved.lines))return;
    const count=saved.lines.reduce((sum,line)=>sum+(Number.isSafeInteger(line?.quantity)&&line.quantity>0?line.quantity:0),0);
    if(count<1||count>3)return;
    const message=document.createElement("aside");message.setAttribute("role","status");message.setAttribute("aria-label","Saved trial selection");
    message.style.cssText="position:fixed;bottom:20px;left:20px;z-index:9999;background:#f6fbf5;color:#173c20;border:2px solid #30833b;box-shadow:0 8px 30px #0002;border-radius:16px;padding:14px 16px;max-width:min(370px,calc(100vw - 40px));font:600 14px/1.4 system-ui,sans-serif";
    const title=document.createElement("div");title.textContent=`Your ${count} trial ${count===1?"jar is":"jars are"} saved.`;
    const link=document.createElement("a");link.href="/pages/products-samples";link.textContent="Resume your trial selection →";link.style.cssText="color:#176a2c;display:inline-block;margin-top:7px;text-decoration:underline";
    const close=document.createElement("button");close.type="button";close.textContent="×";close.setAttribute("aria-label","Dismiss trial reminder");close.style.cssText="position:absolute;right:9px;top:5px;border:0;background:transparent;color:#173c20;cursor:pointer;font-size:22px";
    close.addEventListener("click",()=>{try{sessionStorage.setItem("ff-trial-reminder-dismissed","yes")}catch{}message.remove()});
    message.append(title,link,close);body.append(message);
  }catch{}
};
offerTrialResume();
// Bound both response headers and response-body reads. Mutations are never retried here.
const walletRequestHeaders=(url,initial)=>{
  const headers=new Headers(initial||{}),target=new URL(url,location.origin);
  headers.delete("X-OTP-NCA-Token");
  if(target.origin!==location.origin||!target.pathname.startsWith("/apps/future-wallet/"))return headers;
  try{
    if(!localStorage.getItem("otp_plus_logout_pending")){
      const token=localStorage.getItem("otp_plus_nca_session_token")||sessionStorage.getItem("otp_plus_nca_session_token");
      if(typeof token==="string"&&/^[\x21-\x7e]{1,8192}$/.test(token))headers.set("X-OTP-NCA-Token",token);
    }
  }catch{}
  return headers;
};
const cartRequestJSON = async (url, options = {}, format = "json") => {
  const controller = new AbortController();
  let timeout;
  const expired = new Promise((_, reject) => {
    timeout = setTimeout(() => {
      controller.abort();
      const error = new Error("The cart request took too long. Please check your cart.");
      error.name = "TimeoutError"; reject(error);
    }, options.method === "POST" ? 20000 : 12000);
  });
  try {
    return await Promise.race([(async () => {
      const response = await fetch(url, { ...options, headers: walletRequestHeaders(url,options.headers), signal: controller.signal });
      let value;
      try { value = await response[format](); }
      catch (error) { error.httpStatus = response.status; throw error; }
      if (!response.ok || (format === "json" && Number(value?.status) >= 400)) {
        const error = new Error(value?.description || value?.message || window.ffCartStrings.error);
        error.httpStatus = Number(value?.status) || response.status;
        throw error;
      }
      return value;
    })(), expired]);
  } finally { clearTimeout(timeout); }
};
const updateCartCount = state => {
  if (!Number.isSafeInteger(state?.item_count)) return;
  document.querySelectorAll("[data-cart-count]").forEach(node => node.textContent = state.item_count);
};
let cartRequest=0;const closeCart=(focus=!1)=>{body.classList.remove("cart-sidebar-show"),document.querySelectorAll("[data-cart-sidebar]").forEach(b=>b.setAttribute("aria-expanded","false")),focus&&returnFocus?.focus()},showError=(container,message,state="error")=>{
  let box=container.querySelector(".ff-cart-error");
  if(!box){box=document.createElement("div");box.className="ff-cart-error";container.append(box)}
  box.setAttribute("role",state==="success"?"status":"alert");
  box.dataset.state=state;
  box.style.borderColor=state==="success"?"#30833b":"";
  box.style.background=state==="success"?"#eef7ef":"";
  box.replaceChildren(document.createTextNode(message||window.ffCartStrings.error));
  const link=document.createElement("a");
  link.href=window.routes.cart;link.textContent=window.ffCartStrings.viewCart;
  box.append(document.createTextNode(" "),link);
},openCart=async trigger=>{if(!cart){location.assign(window.routes.cart);return}trigger&&(returnFocus=trigger),closeMenu(),body.classList.remove("before-you-leave-show","cart-dropdown-show"),body.classList.add("cart-sidebar-show"),document.querySelectorAll("[data-cart-sidebar]").forEach(b=>b.setAttribute("aria-expanded","true"));const request=++cartRequest,items=cart.querySelector("quick-cart-items");if(!items||!items.querySelector("#Cart-Content-Sidebar")){location.assign(window.routes.cart);return}items.classList.add("has-halo-block-loader"),items.setAttribute("aria-busy","true"),cart.focus({preventScroll:!0});try{let state,source;for(let attempt=0;attempt<2;attempt++)try{const values=await Promise.all([
  cartRequestJSON(window.routes.cart+".js",{headers:{Accept:"application/json"},cache:"no-store"}).then(value=>{if(request===cartRequest)updateCartCount(value);return value}),
  cartRequestJSON(window.routes.cart+"?view=ajax_side_cart",{cache:"no-store"},"text")
]);if(state=values[0],source=new DOMParser().parseFromString(values[1],"text/html").querySelector("#Cart-Content-Sidebar"),!source)throw Error("Cart markup missing");break}catch(error){if(attempt===1)throw error}if(request!==cartRequest)return;items.querySelector("#Cart-Content-Sidebar").innerHTML=source.innerHTML,items.querySelectorAll(".ff-cart-error").forEach(n=>n.remove()),document.querySelectorAll("[data-cart-count]").forEach(n=>n.textContent=state.item_count);const countLabel=source.getAttribute("data-cart-count-label");if(countLabel&&document.querySelectorAll(".cart-count-bubble .visually-hidden").forEach(n=>n.textContent=countLabel),window.show_multiple_currencies&&window.Currency?.convertAll){const currency=document.querySelector("#currencies .active")?.getAttribute("data-currency");currency&&window.Currency.convertAll(window.shop_currency,currency,"span.money","money_format")}document.dispatchEvent(new CustomEvent("cart:updated",{detail:{cart:state}}))}catch(error){console.warn("Cart refresh failed",error),request===cartRequest&&showError(items,window.ffCartStrings.error)}finally{request===cartRequest&&(items.classList.remove("has-halo-block-loader"),items.removeAttribute("aria-busy"))}};let changingCart=false;
const changeCart=async(input,quantity)=>{
  if(changingCart||addingCart||!Number.isInteger(quantity)||quantity<0)return;
  const owner=input.closest("cart-items"),items=owner?(owner.querySelector("[data-cart]")||owner):cart?.querySelector("quick-cart-items");
  if(!items){location.assign(window.routes.cart);return}
  let previousQuantity=null,mutationStarted=false;
  changingCart=true;items.classList.add("has-halo-block-loader");items.setAttribute("aria-busy","true");items.inert=true;
  try{
    const before=await readCart(),id=String(input.dataset.line||"");
    if(!Array.isArray(before.items))throw Error(window.ffCartStrings.error);
    let index=before.items.findIndex(item=>item.key===id);
    if(index<0){
      const matches=before.items.map((item,index)=>({item,index})).filter(({item})=>String(item.variant_id)===id);
      if(matches.length===1)index=matches[0].index;
    }
    if(index<0)throw Error("Your cart changed. Open your cart again before changing this item.");
    previousQuantity=before.items[index].quantity;
    // Existing invalid carts must remain repairable: decreases and removals are always allowed.
    if(quantity>before.items[index].quantity){
      const proposed=before.items.map((item,i)=>i===index?{...item,quantity}:item);
      const policyError=trialCartError(proposed);if(policyError)throw Error(policyError);
    }
    mutationStarted=true;
    const result=await cartRequestJSON(window.routes.cart_change_url+".js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:before.items[index].key||id,quantity})});
    updateCartCount(result);
    if(owner&&typeof owner.update==="function"){
      const rendered=await owner.update(result);
      if(rendered===false)showError(items,"Your cart was updated, but its display could not refresh. Open your cart to see the latest quantities.","success");
    }else await openCart();
  }catch(error){
    if(!mutationStarted&&previousQuantity!==null&&"value" in input)input.value=String(previousQuantity);
    showError(items,error.message||window.ffCartStrings.error);
  }
  finally{changingCart=false;items.inert=false;items.classList.remove("has-halo-block-loader");items.removeAttribute("aria-busy")}
};document.addEventListener("change",event=>{const input=event.target.closest("[data-cart-quantity]");input&&(event.stopImmediatePropagation(),changeCart(input,Number(input.value)))},!0);const pending=new WeakSet;
const addStorageKey="ff-storefront-pending-add-v1";
let addingCart=false,pendingAdds=Object.create(null);
try {
  const saved=JSON.parse(sessionStorage.getItem(addStorageKey)||"{}");
  if(saved&&typeof saved==="object"&&!Array.isArray(saved)){
    for(const [key,value] of Object.entries(saved)){
      if(value&&/^\d+$/.test(String(value.variant))&&Number.isSafeInteger(value.quantity)&&value.quantity>0&&Number.isSafeInteger(value.before)&&value.before>=0){
        pendingAdds[key]=value;
      }
    }
  }
}catch{}
const saveAdds=()=>{try{Object.keys(pendingAdds).length?sessionStorage.setItem(addStorageKey,JSON.stringify(pendingAdds)):sessionStorage.removeItem(addStorageKey)}catch{}};
const clearAdd=key=>{delete pendingAdds[key];saveAdds()};
const readCart=()=>cartRequestJSON(window.routes.cart+".js",{headers:{Accept:"application/json"},cache:"no-store"});
const trialVariants=new Set(["67811259547750","67811259580518","43389270360166","67811259711590","67811259744358","67811259777126","67811259809894","67811259842662","67811259875430","67811259940966","67811259973734","67811260006502","67811260039270","67811260104806","67811260170342","67811260203110"]);
const trialCartError=items=>{
  let trials=0;
  for(const item of items){
    const quantity=Number(item.quantity);
    if(!Number.isSafeInteger(quantity)||quantity<0)throw Error(window.ffCartStrings.error);
    if(trialVariants.has(String(item.variant_id)))trials+=quantity;
  }
  if(trials>3)return "You can order up to 3 trial packs in total. Remove an extra trial pack before adding another.";
  return "";
};
const matchingQuantity=(state,record)=>{
  if(!Array.isArray(state?.items))throw Error(window.ffCartStrings.error);
  return state.items.reduce((sum,item)=>{
    if(!Number.isSafeInteger(item.quantity)||item.quantity<0)throw Error(window.ffCartStrings.error);
    const plan=String(item.selling_plan_allocation?.selling_plan?.id||"");
    return sum+(String(item.variant_id)===record.variant&&plan===record.plan?item.quantity:0);
  },0);
};
const unresolvedMessage="We could not confirm this addition. Check your cart before trying again. This request will not add the items a second time.";
const add=async(form,button)=>{
  if(pending.has(form)||button?.disabled||!form.reportValidity())return;
  if(addingCart||changingCart){showError(form,"Another cart update is in progress. Please wait.");return}
  const data=new FormData(form);
  if(!data.get("id")){showError(form,window.variantStrings.select);return}
  if(!data.get("quantity"))data.set("quantity","1");
  const variant=String(data.get("id")),plan=String(data.get("selling_plan")||""),quantity=Number(data.get("quantity"));
  if(!/^\d+$/.test(variant)||!Number.isSafeInteger(quantity)||quantity<1){showError(form,"Choose a valid quantity before adding to your cart.");return}
  const key=variant+":"+plan,label=button.querySelector(".text")||button,original=label.textContent;
  let record=null,postStarted=false;
  pending.add(form);addingCart=true;
  form.querySelectorAll(".ff-cart-error").forEach(node=>node.remove());
  button.disabled=true;button.classList.add("is-loading");button.setAttribute("aria-busy","true");label.textContent=window.variantStrings.addingToCart;
  try{
    const before=await readCart();updateCartCount(before);
    if(pendingAdds[key]){
      record=pendingAdds[key];
      const observed=matchingQuantity(before,record);
      if(observed>=record.before+record.quantity){
        clearAdd(key);showError(form,"Your cart contains the requested quantity. Please review your cart.","success");await openCart(button);
        return;
      }
      if(record.phase==="settled"&&observed<=record.before){
        clearAdd(key);
      }else{
        if(record.phase==="settled"&&observed>record.before){
          clearAdd(key);showError(form,"Only "+(observed-record.before)+" of the requested "+record.quantity+" items were added. Please review your cart.");await openCart(button);
        }else showError(form,unresolvedMessage);
        return;
      }
    }
    const policyError=trialCartError([...before.items,{variant_id:variant,quantity}]);
    if(policyError)throw Error(policyError);
    record={variant,plan,quantity,before:matchingQuantity(before,{variant,plan}),phase:"pending"};
    pendingAdds[key]=record;saveAdds();postStarted=true;
    const result=await cartRequestJSON(window.routes.cart_add_url+".js",{method:"POST",headers:{Accept:"application/json","X-Requested-With":"XMLHttpRequest"},body:data});
    clearAdd(key);
    if(result.key)document.cookie="added-item="+encodeURIComponent(result.key)+"; path=/; SameSite=Lax";
    showError(form,"Added to your cart.","success");
    await openCart(button);
  }catch(error){
    if(!postStarted){showError(form,error.message||window.ffCartStrings.error)}
    else{
      const completedRejection=error.httpStatus>=400&&error.httpStatus<500;
      if(completedRejection){record.phase="settled";pendingAdds[key]=record;saveAdds()}
      let after=null;
      try{const state=await readCart();updateCartCount(state);after=matchingQuantity(state,record)}catch{}
      if(after!==null&&after>=record.before+record.quantity){clearAdd(key);showError(form,"Your cart contains the requested quantity. Please review your cart.","success");await openCart(button)}
      else if(after!==null&&after>record.before){
        if(completedRejection)clearAdd(key);
        showError(form,completedRejection?"Only "+(after-record.before)+" of the requested "+record.quantity+" items were added. Please review your cart.":"Your cart has changed, but we could not confirm the full addition. Please review your cart. We have not retried the request.");
        await openCart(button);
      }
      else if(completedRejection&&after!==null){clearAdd(key);showError(form,error.message||window.ffCartStrings.error)}
      else showError(form,unresolvedMessage);
    }
  }finally{
    pending.delete(form);addingCart=false;button.disabled=false;button.classList.remove("is-loading");button.removeAttribute("aria-busy");label.textContent=original;
  }
};
// This supplements native checkout validation; it does not replace server-side rules.
const checkoutPending=new WeakSet(),checkoutAllowed=new WeakMap();
const nativeCartCheckout=(form,submitter)=>{
  if(!submitter||submitter.form!==form||submitter.name!=="checkout"||submitter.type!=="submit"||String(form.method).toLowerCase()!=="post")return null;
  try{
    const action=new URL(form.action,location.origin),cartURL=new URL(window.routes.cart,location.origin);
    if(action.origin!==location.origin||action.pathname!==cartURL.pathname)return null;
    if(submitter.id==="cart-checkout")return form.closest("cart-items");
    if(submitter.id==="cart-sidebar-checkout"&&form.id==="cart-sidebar-form")return form.closest("#halo-cart-sidebar");
  }catch{}
  return null;
};
const cartMarkupHasTrials=root=>Array.from(root.querySelectorAll("[data-cart-quantity-id]")).some(input=>trialVariants.has(String(input.dataset.cartQuantityId)));
const checkoutNotice=(form,message,state="error")=>{
  showError(form,message,state);
  const box=form.querySelector(".ff-cart-error");
  if(box){
    box.dataset.ffCheckoutNotice="";
    if(state==="pending"){
      box.setAttribute("role","status");box.style.borderColor="#d4ddd5";box.style.background="#f5f7f4";
    }
  }
  return box;
};
const checkoutSignIn=form=>{
  const box=checkoutNotice(form,"Sign in with your mobile number to continue. Your trial cart is saved.");
  if(!box)return;
  const returnCart=new URL(window.routes.cart,location.origin);
  const preview=new URL(location.href).searchParams.get("preview_theme_id");
  if(preview&&/^\d+$/.test(preview))returnCart.searchParams.set("preview_theme_id",preview);
  const destination=returnCart.pathname+returnCart.search;
  const link=document.createElement("a");link.href="/pages/kp-account?view=ff-account";link.textContent="Continue with mobile OTP";
  const open=async()=>{if(window.ffAccountSession?.requestLogin){await window.ffAccountSession.refresh();await window.ffAccountSession.requestLogin(destination);}};
  link.addEventListener("click",event=>{if(window.ffAccountSession?.requestLogin){event.preventDefault();event.stopImmediatePropagation();void open();}});
  box.append(document.createTextNode(" "),link);
  void open();
};
const preflightCheckout=async(form,submitter)=>{
  if(checkoutPending.has(form))return;
  if(addingCart||changingCart){checkoutNotice(form,"Your cart is being updated. Wait for it to finish, then choose Checkout.");return}
  if(submitter.disabled||!form.reportValidity())return;
  checkoutPending.add(form);
  const previousBusy=submitter.getAttribute("aria-busy");submitter.setAttribute("aria-busy","true");
  checkoutNotice(form,"Checking your trial cart and eligibility…","pending");
  try{
    const state=await readCart();
    if(!Array.isArray(state?.items))throw new Error("Your cart could not be verified. Please try again.");
    const policyError=trialCartError(state.items);
    if(policyError){checkoutNotice(form,policyError);return}
    const hasTrials=state.items.some(item=>trialVariants.has(String(item.variant_id))&&item.quantity>0);
    if(hasTrials){
      let eligibility;
      try{
        eligibility=await cartRequestJSON("/apps/future-wallet/trial-eligibility",{credentials:"same-origin",cache:"no-store",redirect:"error",headers:{Accept:"application/json"}});
      }catch(error){
        if(error.httpStatus===401){window.ffAccountSession?.invalidate?.();checkoutSignIn(form);}
        else checkoutNotice(form,"We could not verify trial eligibility right now. Your cart is unchanged. Please try Checkout again.");
        return;
      }
      if(eligibility?.eligible!==true||eligibility.reason!=="ELIGIBLE"){
        checkoutNotice(form,eligibility?.reason==="ALREADY_ORDERED"?"A trial order already exists for this account. The trial offer is limited to one order per customer. Please review your existing order or contact FAIMLY FARM.":"Trial eligibility is unavailable for this account. Your cart is unchanged. Please try again or contact FAIMLY FARM.");
        return;
      }
      // Eligibility can take time. Verify the cart again before allowing its native submit.
      const current=await readCart();
      if(!Array.isArray(current?.items))throw new Error("Your cart could not be verified. Please try again.");
      const currentError=trialCartError(current.items);
      if(currentError){checkoutNotice(form,currentError);return}
    }
    if(addingCart||changingCart){checkoutNotice(form,"Your cart changed while it was being checked. Wait for the update to finish, then choose Checkout again.");return}
    if(!form.isConnected||submitter.form!==form)return;
    if(submitter.disabled||!form.reportValidity()){checkoutNotice(form,"Please complete the required cart confirmation before choosing Checkout again.");return}
    form.querySelectorAll("[data-ff-checkout-notice]").forEach(node=>node.remove());
    // requestSubmit keeps the original checkout control, HTML validation and app handlers.
    // The permission is consumed by one synchronous submit event and cannot start a loop.
    if(previousBusy===null)submitter.removeAttribute("aria-busy");else submitter.setAttribute("aria-busy",previousBusy);
    checkoutAllowed.set(form,submitter);
    try{form.requestSubmit(submitter)}finally{checkoutAllowed.delete(form)}
  }catch(error){
    checkoutNotice(form,"Your trial cart could not be checked. Your cart is unchanged. Please try Checkout again.");
  }finally{
    checkoutPending.delete(form);
    if(previousBusy===null)submitter.removeAttribute("aria-busy");else submitter.setAttribute("aria-busy",previousBusy);
  }
}
;
const syncTrialNativeCheckout=target=>{
  const button=target?.closest?.("#cart-checkout, #cart-sidebar-checkout");
  if(!button)return;
  const form=button.form;
  const root=form instanceof HTMLFormElement?nativeCartCheckout(form,button):null;
  if(root&&cartMarkupHasTrials(root)){
    // Hulk's selector excludes this class. After eligibility, the original native
    // submit still runs through required confirmations and app submit handlers.
    if(!button.classList.contains("hulkapps-ignore")){
      button.classList.add("hulkapps-ignore");button.dataset.ffTrialHulkIgnore="true";
    }
    return button;
  }else if(button.dataset.ffTrialHulkIgnore==="true"){
    button.classList.remove("hulkapps-ignore");delete button.dataset.ffTrialHulkIgnore;
  }
}
;
const resumeTrialPayNow=()=>{
  const url=new URL(location.href),cartURL=new URL(window.routes.cart,location.origin);
  if(url.pathname!==cartURL.pathname||url.searchParams.get("ff_trial_pay_now")!=="1")return;
  url.searchParams.delete("ff_trial_pay_now");
  history.replaceState(history.state,"",url.pathname+url.search+url.hash);
  const button=syncTrialNativeCheckout(document.querySelector("#cart-checkout"));
  if(!button)return;
  const form=button.form;
  form.scrollIntoView({block:"center",behavior:"instant"});
  if(button.disabled||!form.reportValidity()){
    checkoutNotice(form,window.ffCartStrings.trialConfirmation);
    return;
  }
  button.focus({preventScroll:true});
  void preflightCheckout(form,button);
};
queueMicrotask(resumeTrialPayNow);
document.addEventListener("click",event=>{
const trialCheckout=syncTrialNativeCheckout(event.target);
if(trialCheckout){
  // Own this trial checkout click before app click handlers can redirect directly.
  event.preventDefault();event.stopImmediatePropagation();
  void preflightCheckout(trialCheckout.form,trialCheckout);return;
}
const menuButton=event.target.closest(".mobileMenu-toggle");if(menuButton){event.preventDefault(),event.stopImmediatePropagation(),returnFocus=menuButton,closeCart(),body.classList.remove("before-you-leave-show"),body.classList.add("menu-open"),menuButton.setAttribute("aria-expanded","true"),drawer?.querySelector("[data-menu-close-sidebar]")?.focus();return}if(event.target.closest("[data-menu-close-sidebar]")){event.preventDefault(),event.stopImmediatePropagation(),closeMenu(!0);return}const cartButton=event.target.closest("[data-cart-sidebar]");if(cartButton){event.preventDefault(),event.stopImmediatePropagation(),openCart(cartButton);return}if(event.target.closest("[data-close-cart-sidebar]")){event.preventDefault(),event.stopImmediatePropagation(),closeCart(!0);return}if(event.target.classList.contains("background-overlay")){closeMenu(!0),closeCart(!0);return}const remove=event.target.closest("[data-cart-remove]");if(remove){event.preventDefault(),event.stopImmediatePropagation(),changeCart(remove,0);return}const button=event.target.closest("[data-btn-addtocart]");if(button&&!button.matches(".is-notify-me,.is-soldout")){const form=button.closest("form");form&&(event.preventDefault(),event.stopImmediatePropagation(),add(form,button))}},!0),document.addEventListener("submit",event=>{const form=event.target;if(!(form instanceof HTMLFormElement))return;
const submitter=event.submitter,checkoutRoot=nativeCartCheckout(form,submitter);
if(checkoutRoot){
  if(checkoutAllowed.get(form)===submitter){checkoutAllowed.delete(form);return}
  if(event.defaultPrevented)return;
  if(checkoutPending.has(form)){event.preventDefault();event.stopImmediatePropagation();return}
  // Preserve the existing native path for ordinary carts, without a new network delay.
  if(!cartMarkupHasTrials(checkoutRoot))return;
  event.preventDefault();event.stopImmediatePropagation();void preflightCheckout(form,submitter);return;
}
const button=form.querySelector("[data-btn-addtocart]")||(form.matches(".ffg-buy")?form.querySelector('[type="submit"]'):null);button&&!button.matches(".is-notify-me,.is-soldout")&&(event.preventDefault(),event.stopImmediatePropagation(),add(form,button))},!0),document.addEventListener("keydown",event=>{const active=body.classList.contains("cart-sidebar-show")?cart:body.classList.contains("menu-open")?drawer:null;if(active){if(event.key==="Escape"){event.preventDefault(),closeMenu(),closeCart(),returnFocus?.focus();return}if(event.key==="Tab"){const controls=[...active.querySelectorAll('a[href],button,summary,input,select,[tabindex="0"]')].filter(n=>n.getClientRects().length&&!n.disabled),first=controls[0],last=controls.at(-1);event.shiftKey&&(document.activeElement===first||document.activeElement===active)?(event.preventDefault(),last?.focus()):!event.shiftKey&&document.activeElement===last&&(event.preventDefault(),first?.focus())}}}),window.addEventListener("pageshow",event=>{event.persisted&&(closeMenu(),closeCart())})};document.readyState==="loading"?document.addEventListener("DOMContentLoaded",start,{once:!0}):start()})();

